var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "#282B2B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65667 9.02096L6.95688 7.32117C6.86742 7.23171 6.92706 7.05278 7.07617 7.05278L13.1298 6.12834C13.2193 6.09852 13.3087 6.18798 13.3087 6.30726L12.3843 12.3609C12.3545 12.51 12.2054 12.5696 12.1159 12.4802L10.4161 10.7804C8.59703 12.6591 8.14972 15.4026 9.07416 17.6988C9.43201 18.5636 9.96879 19.3688 10.7143 20.0547C12.0861 21.2773 13.8753 21.8141 15.6049 21.665L15.2173 24.1401C13.1894 24.1699 11.1616 23.5437 9.52148 22.2316C8.53739 21.4563 7.79187 20.5318 7.22527 19.5179C5.37638 16.178 5.85351 11.8838 8.65667 9.02096ZM21.1218 8.30526C19.4816 6.99314 17.424 6.36691 15.426 6.39673L15.0085 8.90168C16.7381 8.75257 18.5274 9.28935 19.8991 10.512C20.6447 11.1979 21.1814 12.003 21.5393 12.8678C22.4637 15.1641 22.0462 17.9076 20.1973 19.7863L18.4976 18.0865C18.4081 17.997 18.2292 18.0567 18.2292 18.2058L17.3047 24.2594C17.2749 24.3489 17.3644 24.4383 17.4836 24.4383L23.5373 23.5139C23.6864 23.4841 23.746 23.335 23.6566 23.2455L21.9568 21.5457C24.7599 18.6829 25.2371 14.3887 23.3882 11.0488C22.8514 10.005 22.0761 9.0806 21.1218 8.30526Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.6e4c93fcfe6e639cd736bb57bc13e5ce.svg";
export { ForwardRef as ReactComponent };